import { usePostMessage } from '../../context/messageContext';
import { Button, ButtonSet } from '../../ui';
import { Label } from '../../screens/optician/testScreenKit';

// "Patient Response" quadrant buttons 1-4 (clinician enters the patient's answer).
const PatientResponseControls = ({ testProgressData }) => {
  const postMessage = usePostMessage();

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 8, width: '100%' }}>
      <Label size={14} weight={700}>
        Patient Response
      </Label>
      <ButtonSet gap={8}>
        {[1, 2, 3, 4].map((quadrant) => (
          <Button
            key={`response-btn-${quadrant}`}
            variant='secondary'
            size='lg'
            style={{ minWidth: 56 }}
            aria-label={`Quadrant ${quadrant}`}
            onClick={() => postMessage({ type: 'opticianQuadrantResponse', content: quadrant })}
            disabled={testProgressData?.testEnded}
          >
            {quadrant}
          </Button>
        ))}
      </ButtonSet>
    </div>
  );
};

export default PatientResponseControls;
